export default function LoadingSpinner({ message = "" }) {
  return (
    <div className="flex min-h-screen items-center justify-center" style={{ backgroundColor: "#E9FCFB" }}>
      <div className="flex flex-col items-center gap-8">

        {/* Oocyte Cell Animation */}
        <div className="relative flex items-center justify-center"> 
          {/* Outer zona pellucida ring */}
          <div className="absolute h-64 w-64 rounded-full border-2 border-dashed border-[#15A79D] opacity-30 animate-spin-slow" />
          {/* Middle ring */}
          <div className="absolute h-52 w-52 rounded-full border border-[#15A79D] opacity-20 animate-pulse" />

          {/* Cell body */}
          <div className="relative h-44 w-44 rounded-full shadow-xl flex items-center justify-center"
            style={{ background: "radial-gradient(circle at 35% 35%, #ffffff, #c8f5f2 60%, #7de8e1)" }}>

            {/* Nucleus */}
            <div className="absolute h-16 w-16 rounded-full animate-pulse"
              style={{ background: "radial-gradient(circle at 40% 40%, #e0faf8, #15A79D)", opacity: 0.85 }} />

            {/* Nucleolus */}
            <div className="absolute h-6 w-6 rounded-full bg-[#013C38] opacity-70" />

            {/* Polar body */}
            <div className="absolute -top-3 -right-1 h-8 w-8 rounded-full border border-[#15A79D] animate-pulse"
              style={{ background: "radial-gradient(circle, #e0faf8, #a8ede9)", opacity: 0.9 }} />

            {/* Cytoplasm granules */}
            <div className="absolute h-3 w-3 rounded-full bg-[#15A79D] opacity-40" style={{ top: "30%", left: "25%" }} />
            <div className="absolute h-2.5 w-2.5 rounded-full bg-[#013C38] opacity-30" style={{ bottom: "28%", right: "22%" }} />
            <div className="absolute h-2 w-2 rounded-full bg-[#15A79D] opacity-50" style={{ top: "55%", left: "60%" }} />
          </div>

          {/* Orbiting sperm cells */}
          <div className="absolute h-64 w-64 animate-orbit">
            <div className="absolute -top-1 left-1/2 -translate-x-1/2 animate-orbit-reverse" style={{ animationDuration: "3s" }}>
              <SpermIcon color="#15A79D" size={24} rotate={90} />
            </div>
          </div>
          <div className="absolute h-64 w-64 animate-orbit-reverse">
            <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 animate-orbit" style={{ animationDuration: "5s" }}>
              <SpermIcon color="#013C38" size={20} rotate={270} opacity={0.6} />
            </div>
          </div>
          <div className="absolute h-52 w-52 animate-orbit" style={{ animationDuration: "4s", animationDelay: "-2s" }}>
            <div className="absolute top-1/2 -right-1 -translate-y-1/2 animate-orbit-reverse" style={{ animationDuration: "4s" }}>
              <SpermIcon color="#15A79D" size={18} rotate={180} opacity={0.5} />
            </div>
          </div>
        </div>

        {/* Dots loader */}
        <div className="flex items-center gap-2">
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              className="h-2.5 w-2.5 rounded-full bg-[#15A79D]"
              style={{ animation: `dotBounce 1.2s ease-in-out ${i * 0.2}s infinite` }}
            />
          ))}
        </div>
  {message && (
          <p className="text-sm font-medium text-[#013C38] animate-pulse tracking-wide">{message}</p>
        )}
      </div>
      <style jsx>{`
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes orbit {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes orbit-reverse {
          from { transform: rotate(360deg); }
          to { transform: rotate(0deg); }
        }
        @keyframes dotBounce {
          0%, 80%, 100% { transform: scale(0.7); opacity: 0.4; }
          40% { transform: scale(1.2); opacity: 1; }
        }
        .animate-spin-slow {
          animation: spin-slow 12s linear infinite;
        }
        .animate-orbit {
          animation: orbit 3s linear infinite;
        }
        .animate-orbit-reverse {
          animation: orbit-reverse 5s linear infinite;
        }
      `}</style>
    </div>
  );
}

function SpermIcon({ color = "#15A79D", size = 16, rotate = 0, opacity = 1 }) {
  return (
    <svg
      width={size}
      height={size * 2}
      viewBox="0 0 10 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${rotate}deg)`, opacity }}
    >
      {/* Head */}
      <ellipse cx="5" cy="4" rx="3.5" ry="4" fill={color} />
      {/* Tail */}
      <path d="M5 8 Q6.5 12 4.5 16 Q3.5 18 5 20" stroke={color} strokeWidth="1.2" strokeLinecap="round" fill="none" />
    </svg>
  );
}

export function CompactLoader({ message = "" }) {
  return (
    <div className="flex items-center justify-center gap-3 py-8">
      <div className="flex items-center gap-1.5">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="h-2 w-2 rounded-full bg-[#15A79D]"
            className="h-2 w-2 rounded-full bg-[#065CB3]"
            style={{ animation: `dotBounce 1.2s ease-in-out ${i * 0.2}s infinite` }}
          />
       
        ))}
      </div>
      {message && <span className="text-sm text-gray-600">{message}</span>}
      <style jsx>{`
        @keyframes dotBounce {
          0%, 80%, 100% { transform: scale(0.7); opacity: 0.4; }
          40% { transform: scale(1.2); opacity: 1; }
        }
      `}</style>
    </div>
  );
}

export function ButtonLoader() {
  return (
    <div className="h-4 w-4 animate-spin rounded-full border-2 border-white/30 border-t-white"></div>
  );
}
